import { tagName } from "@ember-decorators/component"
import Component from "@ember/component"
import { action, computed, get, set } from "@ember/object"
import PromiseProxyMixin from "@ember/object/promise-proxy-mixin"
import ObjectProxy from "@ember/object/proxy"
import { inject as service } from "@ember/service"
import findMany from "cc-frontend/helpers/find-many"
import _ from "lodash"

class ObjectPromiseProxy extends ObjectProxy.extend(PromiseProxyMixin) {}

@tagName("")
export default class ImportLessonsSelectCourse extends Component {
  isOpen = true

  @service
  rpc

  @service
  session

  @service("ember-store")
  store

  @service
  query

  onSelectCourse = () => {}

  init() {
    super.init(...arguments)
    this.selectedSchoolYearId = null
    this.viewingRecent = true
    this.hasRecent = true
  }

  @computed
  get importablePlanbooks() {
    return ObjectPromiseProxy.create({
      promise: get(this, "query")
        .fetch({ id: get(this, "session.userId"), type: "importable_planbooks_for_user" })
        .then((response) => response.data),
    })
  }

  didReceiveAttrs() {
    super.didReceiveAttrs(...arguments)
    if (get(this, "cardStackBelongsToCourse.attributes.recentlyImportedCourses.length") === 0) {
      set(this, "viewingRecent", false)
      set(this, "hasRecent", false)
      set(this, "selectedSchoolYearId", "SY20172018")
    }
  }

  @computed("importablePlanbooks.isFulfilled")
  get schoolYearIds() {
    return _.chain(get(this, "importablePlanbooks.content.results.planbooks"))
      .map((planbook) => planbook.schoolYearId)
      .uniq()
      .sort()
      .reverse()
      .value()
  }

  @findMany("schoolYearIds", "school-year")
  schoolYears

  @computed("importablePlanbooks.isFulfilled", "selectedSchoolYearId")
  get planbooks() {
    let selectedSchoolYearId = get(this, "selectedSchoolYearId")
    let ownerId = get(this, "session.userId")
    return _.chain(get(this, "importablePlanbooks.content.results.planbooks"))
      .filter((planbook) => planbook.schoolYearId === selectedSchoolYearId)
      .sortBy((planbook) => {
        // Put your planbooks at the top
        if (planbook.ownerId === ownerId) {
          return "A1"
        } else {
          return planbook.ownerLastName
        }
      })
      .groupBy((planbook) => planbook.ownerId)
      .map((v, k) => {
        let userName = k === ownerId ? "My Planbooks" : get(_.first(v), "ownerFullName")
        let initials = get(_.first(v), "ownerInitials")
        return {
          name: userName,
          initials: initials,
          planbooks: v,
        }
      })
      .value()
  }

  @action
  selectYear(year) {
    set(this, "selectedSchoolYearId", year.id)
    set(this, "viewingRecent", false)
  }

  @action
  selectCourse(planbookId, courseId, focusedItemId) {
    this.onSelectCourse(planbookId, courseId, focusedItemId)
  }

  @action
  selectRecent() {
    set(this, "viewingRecent", true)
    set(this, "selectedSchoolYearId", null)
  }
}
